setUserVideoData